import React from "react";

class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || String(error) };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-md-navy text-white flex items-center justify-center p-8">
          <div className="max-w-lg text-center">
            <h1 className="text-xl font-bold">Erreur du panneau admin</h1>
            <p className="mt-4 text-sm text-white/60 break-words">{this.state.message}</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-6 md-btn-solid px-5 py-2.5"
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AdminErrorBoundary;
